import React from 'react';
import { Play, Globe, Leaf, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const VideoSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-800 mb-6">
            {t('video-title')}
          </h2>
          <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
            {t('video-subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="bg-neutral-100 rounded-2xl aspect-video flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-primary-600 opacity-20"></div>
              
              <div className="relative z-10">
                <button className="bg-white/90 hover:bg-white transition-all duration-300 p-6 rounded-full shadow-lg transform hover:scale-110">
                  <Play className="h-12 w-12 text-primary-600 ml-1" />
                </button>
              </div>
              
              <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-neutral-800">{t('video-video-title')}</h4>
                    <p className="text-sm text-neutral-600">{t('video-duration')}</p>
                  </div>
                  <div className="text-sm text-neutral-500">
                    {t('video-quality')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-semibold text-neutral-800 mb-4">
                {t('video-content-title')}
              </h3>
              <p className="text-neutral-600 leading-relaxed mb-6">
                {t('video-content-desc')}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-4 bg-primary-50 rounded-xl">
                <Globe className="h-8 w-8 text-primary-600 mx-auto mb-3" />
                <div className="text-2xl font-bold text-primary-600 mb-1">2%</div>
                <div className="text-sm text-neutral-600">{t('video-stat-1')}</div>
              </div>
              <div className="text-center p-4 bg-primary-50 rounded-xl">
                <Leaf className="h-8 w-8 text-primary-600 mx-auto mb-3" />
                <div className="text-2xl font-bold text-primary-600 mb-1">50K+</div>
                <div className="text-sm text-neutral-600">{t('video-stat-2')}</div>
              </div>
              <div className="text-center p-4 bg-primary-50 rounded-xl">
                <TrendingUp className="h-8 w-8 text-primary-600 mx-auto mb-3" />
                <div className="text-2xl font-bold text-primary-600 mb-1">%40</div>
                <div className="text-sm text-neutral-600">{t('video-stat-3')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection; 